import {useEffect, useState} from "react";
import {Repositories} from "../repositories/Repositories";
import { Config } from '../repositories/config/Config';

const useConfigListenerHook = (): Config => {
    const [config, setConfig] = useState<Config>({
        heatmap_min_max_intensity: 200,
        heatmap_radius: 50
    });

    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = (): void => {
        Repositories.config.fetchConfig()
            .then((config) => setConfig(config));
    };

    return config;
};

export default useConfigListenerHook;
